import React from "react";
import { Field } from "redux-form";
import * as normalizers from "common/normalizers";
import * as validations from "common/validations";
import FieldGroup from "components/FieldGroup";
import InputPack from "components/InputPack";
import SelectPack from "components/SelectPack2";
import CheckboxPack from "components/CheckboxPack";

class HealthSupplementsDrenching extends React.Component {
    constructor(props) {
        super(props);
        const formState = props.formState || {};
        const drenching = props.healthSupplements.drenching || {};
        this.state = {
            disableMagnesiumFields: !((formState.mgMaterial && formState.mgMaterial !== "None") || (drenching.mgMaterial && drenching.mgMaterial !== "None")),
            disableSaltFields: !(formState.saltMaterial || drenching.saltMaterial),
            disableLimeFlourFields: !(formState.limeFlourMaterial || drenching.limeFlourMaterial),
        };
    }

    _mgMaterialChanged = (e) => {
        this.setState({
            disableMagnesiumFields: e.target.value === "None",
        });
    };

    _saltMaterialChanged = (e, checked) => {
        this.setState({
            disableSaltFields: checked === false,
        });
    };

    _limeFlourMaterialChanged = (e, checked) => {
        this.setState({
            disableLimeFlourFields: checked === false,
        });
    };

    render() {
        const { magnesiumSources } = this.props;

        return (
            <div className="Grid-cell u-lg-width2of3">
                <h3>Drenching regime</h3>
                <FieldGroup>
                    <Field name="mgMaterial" label="Drench type" options={magnesiumSources} dataWidth="33" onChange={this._mgMaterialChanged} component={SelectPack} />
                    <Field name="mgRate_gCowDay" label="Drenching rate" requiredLabel={true} disabled={this.state.disableMagnesiumFields} placeholder={this.state.disableMagnesiumFields ? "-" : "0"} type="text" uom="g/cow/day" dataWidth="33" normalize={normalizers.integer} validate={[validations.range(1, 99999)]} component={InputPack} />
                    <Field name="mgNumberOfWeeksUsed" label="Number of weeks" requiredLabel={true} disabled={this.state.disableMagnesiumFields} placeholder={this.state.disableMagnesiumFields ? "-" : "0"} type="text" uom="weeks" dataWidth="33" normalize={normalizers.integer} validate={[validations.range(1, 52)]} component={InputPack} />
                </FieldGroup>
                <FieldGroup>
                    <Field name="saltMaterial" label="Salt" type="checkbox" onChange={this._saltMaterialChanged} dataWidth="33" component={CheckboxPack} />
                    <Field name="saltRate_gCowDay" noLabel={true} disabled={this.state.disableSaltFields} placeholder={this.state.disableSaltFields ? "-" : "0"} uom="g/cow/day" dataWidth="33" normalize={normalizers.integer} validate={[validations.range(1, 99999)]} type="text" component={InputPack} />
                    <Field name="saltNumberOfWeeksUsed" noLabel={true} disabled={this.state.disableSaltFields} placeholder={this.state.disableSaltFields ? "-" : "0"} uom="weeks" dataWidth="33" normalize={normalizers.integer} validate={[validations.range(1, 52)]} type="text" component={InputPack} />
                </FieldGroup>
                <FieldGroup>
                    <Field name="limeFlourMaterial" label="Lime flour" type="checkbox" onChange={this._limeFlourMaterialChanged} dataWidth="33" component={CheckboxPack} />
                    <Field name="limeFlourRate_gCowDay" noLabel={true} disabled={this.state.disableLimeFlourFields} placeholder={this.state.disableLimeFlourFields ? "-" : "0"} uom="g/cow/day" dataWidth="33" normalize={normalizers.integer} validate={[validations.range(1, 99999)]} type="text" component={InputPack} />
                    <Field name="limeFlourNumberOfWeeksUsed" noLabel={true} disabled={this.state.disableLimeFlourFields} placeholder={this.state.disableLimeFlourFields ? "-" : "0"} uom="weeks" dataWidth="33" normalize={normalizers.integer} validate={[validations.range(1, 52)]} type="text" component={InputPack} />
                </FieldGroup>
                <h3>Dusting regime</h3>
                <FieldGroup>
                    <Field name="mgDusting_kghaYr" label="Magnesium oxide (dusting)" placeholder="0" type="text" uom="kg/yr" dataWidth="33" normalize={normalizers.integer} validate={[validations.range(0, 99999)]} component={InputPack} />
                    <Field name="saltDusting_kghaYr" label="Salt (dusting)" placeholder="0" type="text" uom="kg/yr" dataWidth="33" normalize={normalizers.integer} validate={[validations.range(0, 99999)]} component={InputPack} />
                    <Field name="limeFlourDusting_kghaYr" label="Lime flour (dusting)" placeholder="0" type="text" uom="kg/yr" dataWidth="33" normalize={normalizers.integer} validate={[validations.range(0, 99999)]} component={InputPack} />
                </FieldGroup>
            </div>
        );
    }
}

export default HealthSupplementsDrenching;
